import React from "react";
import PropTypes from "prop-types";
import withErrorGuard from "../../../../../HOC/withErrorGuard";
import TranscriptGnomadTable from "./TranscriptGnomadTable";
import LOFProbabilityTable from "./LOFProbabilityTable";
import GnomadVariantsTable from "./GnomadVariantsTable";
import GnomadExplanation from "./GnomadExplanation";
import GnomadEntry from "../GnomadEntry";

function GnomadGenesV4({ gnomadEntry, geneSymbol }) {
  if (!gnomadEntry) return null;

  const gnomadItem = new GnomadEntry(gnomadEntry);

  return (
    <div className="tw-my-3">
      <GnomadExplanation gnomadEntry={gnomadItem} />
      <TranscriptGnomadTable gnomadEntry={gnomadItem} gene={geneSymbol} />
      <LOFProbabilityTable gnomadEntry={gnomadItem} />
      <GnomadVariantsTable gnomadEntry={gnomadItem} />
    </div>
  );
}

GnomadGenesV4.propTypes = {
  geneSymbol: PropTypes.string,
  gnomadEntry: PropTypes.shape({}),
};

GnomadGenesV4.defaultProps = {
  gnomadEntry: null,
  geneSymbol: "",
};

export default withErrorGuard(GnomadGenesV4, "gnomadGenes", "GnomAD Genes");
